import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/authContext'; // ✅ import the context
import './tailwind.css'; // Import Tailwind CSS

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <AuthProvider>         {/* ✅ Wrap App in AuthProvider */}
        <App />
      </AuthProvider>
    </React.StrictMode>
  </BrowserRouter>
);
